import styled from 'styled-components'
import cssVar from '../../../assets/css/variables';

export const ModalWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: white;
    border-radius: 8px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 50px 20px;
    filter: drop-shadow(0px 0px 8px gray);
    min-width: 410px;
    min-height: 250px;
`;
export const CloseButton = styled.button`
    width: 200px;
    height: 50px;
    border: none;
    border-radius: 8px;
    align-self: center;
    font-size: 30px;
    border: 2px solid #807cd7;
    filter: drop-shadow(0 0 2px gray);
    color: #ffffff;
    font-weight: 600;
    background-color: #4945be;
    &:disabled {
        color: ${cssVar.colorWhite};
        background-color: #c0c0c9;
        border: 1px solid #c0c0c9;
      }
`
export const Heading = styled.div`
    font-size: 30px;
`;
export const Source = styled.div`
    font-size: 20px;
    padding: 20px 0;
    color: #666666;
`;